export const transactionMappingBackup = [
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'ATM-withdrawal',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'CDM-cash-deposit',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'card-charge',
    description: 'CARD'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'card-payment',
    description: 'CARD'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'cash-equivalent-deposit',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'cash-equivalent-withdrawal',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'incoming-cheque',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'incoming-local-fund-transfer',
    description: 'REMITTANCE'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'incoming-overseas-fund-transfer',
    description: 'REMITTANCE'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'outgoing-cheque',
    description: 'CASA'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'outgoing-local-fund-transfer',
    description: 'REMITTANCE'
  },
  {
    codeType: 'TRANSACTION_PRODUCT_MAPPING',
    code: 'outgoing-overseas-fund-transfer',
    description: 'REMITTANCE'
  }
];
